import { render, staticRenderFns } from "./AccountProps.vue?vue&type=template&id=e1a9484e&"
import script from "./AccountProps.vue?vue&type=script&lang=js&"
export * from "./AccountProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports